export default __webpack_public_path__ + "static/medium-image-completely-1-03f2871af9b17c6c6c6e193f5a331b93.png";